/**
 * PreviewFrame (CHAP-593): a rendered Discovery email, in an iframe with every
 * sandbox restriction on. An empty sandbox attribute means no script, no
 * forms, no popups, no top-level navigation and an opaque origin, so nothing
 * in the email can reach the admin page or its session. Do not add allow-*
 * tokens: the preview needs none of them.
 */
export function PreviewFrame({ html, title }: { html: string; title: string }) {
  return (
    <iframe
      title={title}
      sandbox=""
      referrerPolicy="no-referrer"
      srcDoc={html}
      className="w-full h-[640px] rounded border border-gray-200 bg-white"
    />
  );
}
